// extracted by mini-css-extract-plugin
export default {"filter-type-select":"safety-cases-filter_filter-type-select__fwwcn","filter-type-definition":"safety-cases-filter_filter-type-definition__H0trW"};